// extracted by mini-css-extract-plugin
export default {"content":"Areas_content__joEm9","topBox":"Areas_topBox__j4FSl"};